import idRestorationIcon from '../../assets/img/homepage-banner-id-restoration-icon.svg';
import walletProtectionIcon from '../../assets/img/homepage-banner-lost-wallet-icon.svg';
import monitoringIcon from '../../assets/img/homepage-banner-monitoring-icon.svg';
import {
  LANGUAGE_CODE_FR_CA,
  ROUTE_PATH_ACTIVATE,
  ROUTE_PATH_HOME,
  ROUTE_PATH_IDENTITY,
  ROUTE_PATH_PROTECTION,
  ROUTE_PATH_VIDEO,
  URL_IDENTITY_LOGIN_PAGE_FR_CA,
  URL_INTX_LOGIN_PAGE_FR_CA
} from '../../constants';
import { HomePageV3Translations } from '../types';

export const translations: HomePageV3Translations = {
  docTitle: 'Accueil',
  pageTitle: 'Détecter les éléments qui menacent votre identité et y réagir',
  pageTempLoginTitle: 'Détecter les éléments qui menacent votre identité et y réagir grâce',
  pageText: 'EnGarde alimenté par Assist Identité fournit tous vos services de protection de l’identité. Bien que vos services de surveillance en ligne et de suivi du crédit soient entrés en vigueur dès le moment où vous vous êtes inscrit à EnGarde, il est important que vous configuriez votre compte en ligne afin d’avoir accès à ces services et de maximiser votre protection.',
  pageSubtitle: [
    'La Banque de Montréal est fière d&#39;offrir à ses clients Performance, Privilège, Platine, Récompenses Bleu et programme Employés l&#39;accès à EnGarde, sans frais supplémentaires.'
  ].join('\n'),
  pageLoginStateSubtitle: [
    'EnGarde alimenté par Assist Identité fournit tous vos services de protection de l’identité.',
    'Bien que vos services de surveillance en ligne et de suivi du crédit soient entrés en vigueur',
    'dès le moment où vous vous êtes inscrit à EnGarde, il est important que vous configuriez votre',
    'compte en ligne afin d’avoir accès à ces services et de maximiser votre protection.'
  ].join('\n'),
  watchVideo: {
    to: ROUTE_PATH_VIDEO,
    children: 'En Savoir Plus Sur EnGarde'
  },
  watchVideoModalTitle: 'En Savoir Plus Sur EnGarde',
  loginStateWatchVideo: {
    to: ROUTE_PATH_VIDEO,
    children: 'Regarder la vidéo'
  },
  loginStateWatchVideoModalTitle: 'En savoir plus sur EnGarde',
  featureList: {
    lostWalletProtection: {
      icon: {
        src: walletProtectionIcon
      },
      title: 'Une protection contre les menaces que vous connaissez&hellip;',
      summary: [
        `<h2 class="feature-title ${LANGUAGE_CODE_FR_CA}">Protection contre la perte de portefeuille</h2>`,
        '<p class="feature-summary">Annulez toutes vos cartes de paiement en un seul clic ou un seul appel en cas de perte ou de vol</p>'
      ].join('\n'),
      action: {
        to: ROUTE_PATH_PROTECTION,
        children: 'J’ai perdu mon portefeuille ou mes cartes de paiement'
      }
    },
    monitoring: {
      icon: {
        src: monitoringIcon
      },
      title: `Et les menaces dont vous n'êtes pas au courant&hellip;`,
      summary: [
        `<h2 class="feature-title ${LANGUAGE_CODE_FR_CA}">Surveillance et alertes</h2>`,
        '<p class="feature-summary">Ajoutez de l’information à votre liste de surveillance de l’identité en ligne et consultez vos alertes</p>'
      ].join('\n'),
      action: {
        to: '',
        href: URL_INTX_LOGIN_PAGE_FR_CA,
        children: 'Ouvrir une session'
      }
    },
    loginSubmit: {
      icon: {},
      title: 'J’ai déjà un compte en ligne',
      summary: [
        'Excellente nouvelle! Ouvrez une session dès maintenant pour accéder à vos services de protection de l’identité.',
      ].join('\n'),
      action: {
        to: '',
        href: URL_INTX_LOGIN_PAGE_FR_CA,
        children: 'Ouvrir une session'
      }
    },
    setupAccount: {
      icon: {},
      title: 'J’ai besoin de configurer mon compte en ligne',
      summary: [
        'Aucun problème! Saisissez simplement l’adresse courriel que vous aviez fournie au moment de votre inscription à EnGarde et nous vous enverrons un courriel pour vous permettre de créer votre mot de passe et de configurer votre compte en ligne.'
      ].join('\n'),
      form:{
        emailAddress:{
          label:'Adresse courriel',
          placeHolder:'Adresse courriel',
          success:[
            'Si nous avons l’adresse électronique @@emailAddress dans nos dossiers, nous vous ',
            'enverrons un lien pour réinitialiser votre mot de passe. Consultez vos courriels ',
            'indésirables ou vos pourriels si vous ne voyez rien dans votre boîte de réception.'
          ].join(''),
          error:{
            required: 'Veuillez saisir votre adresse courriel.',
            valid:'Veuillez saisir une adresse courriel valide (p. ex., julietremblay@exemple.com).'
          },
        }
      },
      action: {
        to: ROUTE_PATH_IDENTITY,
        children:'ENVOYER'
      }
    },
    idRestoration: {
      icon: {
        src: idRestorationIcon
      },
      title: 'Et un accès à des services de redressement complets',
      summary: [
        `<h2 class="feature-title ${LANGUAGE_CODE_FR_CA}">Restauration de l’identité</h2>`,
        '<p class="feature-summary">Recevez l’aide dont vous avez besoin pour vous remettre sur pied après une menace de vol d’identité </p>'
      ].join('\n'),
      action: {
        to: ROUTE_PATH_IDENTITY,
        children: 'Je crois que mon identité a été compromise'
      }
    }
  },
  nonMemberActions: {
    activate: {
      to: ROUTE_PATH_ACTIVATE,
      children: 'Activer'
    }
  },
  signInAction: {
    to: '',
    href: ROUTE_PATH_HOME,
    children: 'Vous avez déjà un compte?'
  },
  signUpAction: {
    to: '',
    href: `${ROUTE_PATH_ACTIVATE}?token=${process.env.REACT_APP_ACTIVATION_TOKEN}`,
    children: 'Vous n’avez pas de compte? Cliquez ici.'
  },
  maintenancePage:{
    OnGuard:{
      icon: {},
      title: '',
      summary: [
        'Si vous êtes un abonné EnGarde ayant souscrit aux services <span>avant le 26 janvier 2022</span>,',
        'vous pouvez continuer à accéder à vos services ici :'
      ].join('\n'),
      buttonName:'SE CONNECTER',
      action: {
        to: '',
        href: URL_IDENTITY_LOGIN_PAGE_FR_CA,
        children: 'OK'
      }
    },
    idAssist:{
      icon: {},
      title: '',
      summary: [
        'Si vous êtes un nouvel abonné à EnGarde <span>depuis le 26 janvier 2022</span>, accédez à vos services ici :'
      ].join('\n'),
      buttonName:'SE CONNECTER',
      action: {
        to: '',
        href: URL_INTX_LOGIN_PAGE_FR_CA,
        children: 'OK'
      }
    }
  },
  bannerTitle: '<span>Ne faites pas partie des statistiques!</span><br>',
  bannerText:  `<span>Le taux de croissance de la fraude numérique est deux fois plus élevé au Canada que dans le reste du monde. EnGarde vous offre les outils nécessaires pour vous aider à protéger vos renseignements personnels et à vous prémunir contre le risque de fraude d'identité.</span><br>`,
  bannerLink: '<span><u>Cliquez ici pour en savoir plus</u> &#x3009;</span>',
  srOnlyBannerText: [
    '<span>Ne faites pas partie des statistiques!</span><br>',
    `<span>Le taux de croissance de la fraude numérique est deux fois plus élevé au Canada que dans le reste du monde. EnGarde vous offre les outils nécessaires pour vous aider à protéger vos renseignements personnels et à vous prémunir contre le risque de fraude d'identité</span><br>`,
    '<span><u>Cliquez ici pour en savoir plus</u></span>'
  ].join('\n')
};
